/* Ella: hace clickeable texto y flecha:
   - 1er toque en el texto: abre/cierra submenú (no navega)
   - 2º toque en el texto (si ya está abierto): navega
   - Cualquier toque en la flecha: abre/cierra (nunca navega)
*/
(function () {
  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  ready(function () {
    // contenedor del menú móvil (Ella suele renderizar dentro del drawer)
    const root = document.querySelector('#menu-drawer, .menu-drawer, .drawer__inner, .mobile-menu, .mobile-nav');
    if (!root) return;

    root.addEventListener('click', function (e) {
      // flecha (tu HTML usa .icon-dropdown con data-toggle-menu-mb)
      const caret = e.target.closest('.icon-dropdown[data-toggle-menu-mb]');
      // links que abren submenú (niveles 1, 2, 3 de tu snippet)
      const link = e.target.closest(
        [
          'li.menu-lv-item.dropdown > p.menu-lv-1__action > a',
          'li.menu-lv-item.dropdown > a.menu-lv-2__action',
          'li.menu-lv-item.dropdown > a.menu-lv-3__action'
        ].join(',')
      );

      const trigger = caret || link;
      if (!trigger) return;

      const li = trigger.closest('li.menu-lv-item.dropdown');
      if (!li) return;

      const submenu =
        li.querySelector(':scope > .menu-lv__dropdownmenu') ||
        li.querySelector(':scope > .menu-lv__dropdownmenu-2') ||
        li.querySelector(':scope > .menu-dropdown');

      if (!submenu) return;

      const isOpen = li.classList.contains('is-open');

      // Si es la flecha: solo togglear
      if (caret) {
        e.preventDefault();
        e.stopPropagation();
        li.classList.toggle('is-open');
        li.setAttribute('aria-expanded', String(!isOpen));
        return;
      }

      // Si es el texto:
      // cerrado -> abrir (no navegar)
      // abierto -> permitir navegación normal
      if (!isOpen) {
        e.preventDefault();
        li.classList.add('is-open');
        li.setAttribute('aria-expanded', 'true');
      }
      // si ya estaba abierto no prevenimos: el link navega
    });
  });
})();
